import { apiClient } from './api'

export interface AttentionReason {
  kind: 'budget' | 'schedule' | 'overdue' | 'blocked' | 'raid' | 'stale'
  points: number
  text: string
}

export interface AttentionProject {
  project_id: number
  project_name: string
  status: string
  level: 'at_risk' | 'watch'
  score: number
  progress_percent: number
  end_date: string | null
  project_manager_id: number | null
  reasons: AttentionReason[]
}

export interface NeedsAttention {
  as_of: string
  projects: AttentionProject[]
  counts: { at_risk: number; watch: number; checked: number }
}

/** backend/app/services/portfolio_health.py */
export const portfolioHealthService = {
  async needsAttention(limit = 50): Promise<NeedsAttention> {
    const { data } = await apiClient.get<NeedsAttention>('/api/v1/portfolio-health/needs-attention', { params: { limit } })
    return data
  },
}
